module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc22-c9816fbd2778da30c9c89fc422f47fa8.jpg";